/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { RestService } from '../../RestService';

class DomainService extends RestService {
    /** @ngInject */
    constructor($q, resource, $httpParamSerializerJQLike, $log) {
        super($q, resource,  $httpParamSerializerJQLike, $log, false);
        $log.debug('Service \'DomainService\' loaded');
    }
}

export { DomainService };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/organization/service/DomainService.js